<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-12-07 16:20:13
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-02-21 09:28:51
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\views\subsidize\components\dialog\fileListDialog.vue
-->
<template>
  <el-dialog title="查看政策文件" width="80%" custom-class="dialogBody" :close-on-click-modal="false" :visible="showDialog"
    @close="closeDialog">
    <div class="readFile">
      <div class="fileItem" v-for="file in fileList" :key="file.id">
        <div class="file">
          <el-tooltip class="item" effect="light" :content="file.attName" :visible-arrow="false" placement="top">
            <img class="file-img" :src="fileUtrl(file)" />
          </el-tooltip>
          <div class="file-name">
            {{ file.attName }}
          </div>

          <el-button class="downLogo" type="primary" icon="el-icon-download" size="mini"
            @click="handleDownload(file)"></el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    showDialog: Boolean,
    formResult: { type: Array, default: () => ([]) }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_PROXY_URL,
      imgTypes: ['png', 'jpg', 'jpeg', 'JPG', 'JPEG'],
      fileList: [],
    }
  },
  components: {},
  mounted() {
    this.fileList = this.formResult
  },
  methods: {
    // 下载图片（支持海政通PC端）
    handleDownload(row) {
      const { protocol, hostname, port } = window.location;
      const productionUrl = `${protocol}//${hostname}`
      const baseUrl = process.env.NODE_ENV === 'production' ? productionUrl : this.baseUrl;
      let a = document.createElement('a');
      let fileName = row.attName || '';
      if (port) {
        a.href = `${baseUrl}:${port}/card-pu/api/fileserver/file/download/card-new/${row.attId}`
      } else {
        a.href = `${baseUrl}/card-pu/api/fileserver/file/download/card-new/${row.attId}`
      }
      a.download = fileName;
      a.click();
    },
    // 获取文件路径
    fileUtrl(file) {
      let array = file.attName?.split('.')
      if (!array) {
        return require('@/assets/images/commonFile.png')
      }
      let type = array[array.length - 1]
      if (['png', 'jpg', 'jpeg', 'gif', 'bmp'].includes(type)) {
        return this.baseUrl + '/api/fileserver/file/download/card-new/' + file.attId
      } else if (['xls', 'xlsx', 'et', 'ett', 'xlt'].includes(type)) {
        return require('@/assets/images/excel.png')
      } else if (['doc', 'word', 'docx', 'wps'].includes(type)) {
        return require('@/assets/images/doc.png')
      } else if (['pdf'].includes(type)) {
        return require('@/assets/images/pdf.png')
      } else if (['txt'].includes(type)) {
        return require('@/assets/images/commonFile.png')
      } else if (['ppt', 'pptx'].includes(type)) {
        return require('@/assets/images/ppt.png')
      } else if (['rar', 'jar', 'zip', '7z', 'tar', 'zipx'].includes(type)) {
        return require('@/assets/images/zip.png')
      } else {
        return require('@/assets/images/commonFile.png')
      }
      // if (['docx', 'doc'].includes(type.toLowerCase())) {
      //   return require('@/assets/images/doc.png');
      // } else if (['xlsx', 'xls'].includes(type.toLowerCase())) {
      //   return require('@/assets/images/excel.png');
      // } else if (['pdf'].includes(type.toLowerCase())) {
      //   return require('@/assets/images/pdf.png');
      // } else if (this.imgTypes.includes(type.toLowerCase())) {
      //   return `${this.baseUrl}/api/fileserver/file/download/card-new/${file.attId || file.id}`;
      // }
      // return require('@/assets/images/commonFile.png');
    },
    closeDialog() {
      this.$emit('update:showDialog', false);
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  height: 80%;
  margin: 0 auto;
}

::v-deep .el-dialog__body {
  height: 85%;
}

::v-deep .el-dialog.is-fullscreen {
  overflow-y: hidden;
}

::v-deep .el-dialog__header {
  background-color: #e5eef5;
}

.readFile {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;

  .fileItem {
    height: 160px;
    width: 190px;
    margin: 8px;
    display: flex;
    justify-content: center;
    border: 1px solid #dadfed;
    border-radius: 6px;

    .file {
      display: flex;
      flex-direction: column;
      justify-content: center;

      &-img {
        width: 75px;
        height: 80px;
        display: flex;
        margin: 0 auto;
      }

      &-name {
        width: 90%;
        color: black;
        font-size: 14px;
        text-align: center;
        margin: 5px auto;
        padding: 0 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .downLogo {
        margin: 0 auto;
        color: #409eff !important;
        background: #ecf5ff !important;
        border-color: #609eff !important;
      }
    }
  }

  .fileItem:hover {
    border: 1px solid #409eff
  }
}

.el-button--mini,
::v-deep .el-button--mini.is-round {
  padding: 7px;
}
</style>
